import AlertRecordPreview from './AlertRecordPreview';

export default AlertRecordPreview;
export * from './AlertRecordPreview';
